<template>
  <div class="row cover" style="margin:0 30px">
    <div
      :class="{
        'col-sm-12': showPassage,
        'col-sm-6': !showPassage,
        'cover-child': true,
        'passage-box': true
      }"
    >
      <div class="passage">
        <h2 class="text-center">{{ passageDetail.name[$i18n.locale] }}</h2>
        <div class="resolve_content">
          <div class="title">Question:</div>
          <h6 v-html="question_detail.question"></h6>
          <img
            :key="image"
            v-for="image in question_detail.images"
            class="chart"
            :src="image"
          />
        </div>
        <div class="open" @click="showPassage = !showPassage">
          <div class="text" v-show="!showPassage">Expand</div>
          <div class="text" v-show="showPassage">Collapse</div>
        </div>
      </div>
    </div>
    <div v-show="!showPassage" class="col-sm-6 cover-child question-box">
      <div class="question" style="opacity: 1;">
        <div class="speaking_resolve">
          <div class="resolve_content">
            <div class="title">My Answer:</div>
            <div class="exp">
              <div
                v-html="setText(question_detail.user_answers[0])"
                style="margin-bottom:10px"
              ></div>
              <div
                class="ckeditor"
                v-if="examInfo.can_suggest === 1 || examInfo.can_score === 1"
              >
                <div v-if="examInfo.suggest_type === 'outline'">
                  <el-divider content-position="left">
                    <b>{{ $t("GradingSamples.Simple Grading") }}</b>
                  </el-divider>
                </div>
                <div v-else-if="examInfo.suggest_type === 'detail'">
                  <el-divider content-position="left">
                    <b class="vip">
                      <el-tag type="warning" effect="plain">
                        <i class="fas fa-chess-queen"></i>
                        VIP
                      </el-tag></b
                    ><b>{{ $t("GradingSamples.VIP Grading") }}</b></el-divider
                  >
                </div>
                <div v-else>
                  <el-divider content-position="left">
                    <b>Grades and Comments</b>
                  </el-divider>
                </div>
                <div style="margin-bottom:20px">
                  <div v-if="isAdmin">
                    <div
                      v-if="examInfo.can_score === 1"
                      class="d-flex align-items-center"
                    >
                      <b>Response Score:&nbsp;</b>
                      <GradeLevelSelector
                        section="writing"
                        :value="question_detail.score"
                        @change="score => (question_detail.score = score)"
                      />
                    </div>
                    <div class="col-sm-12">
                      <GradingSubScoreTable
                        v-if="examInfo.can_score === 1"
                        :value="
                          (question_detail.answer_score_detail || {})
                            .detail_score_comments
                        "
                        :testCategory="TEST_CATEGORY"
                        :hideSubComment="!examInfo.can_suggest"
                        @change="
                          subScores =>
                            (question_detail.answer_score_detail = {
                              ...(question_detail.answer_score_detail ||
                                {}),
                              detail_score_comments: subScores
                            })
                        "
                      />
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="examInfo.can_score === 1">
                      <b
                        style="line-height:41px"
                        v-if="examInfo.is_scored === 1"
                      >
                        Score:
                        <span class="text-warning" style="font-size:18px">
                          {{ question_detail.score }}</span
                        >
                      </b>
                      <div v-else>
                        <el-button
                          type="success"
                          style="width:100%"
                          disabled
                          plain
                          round
                        >
                          {{ $t("message.unlockScored") }}
                        </el-button>
                      </div>
                    </div>
                    <el-button
                      v-else
                      type="warning"
                      @click="$parent.getAlert()"
                    >
                      {{ $t("toefl.balance.Show Score") }}
                    </el-button>
                    <div class="col-sm-12">
                      <SubScoreTable
                        :value="
                          (question_detail.answer_score_detail || {})
                            .detail_score_comments
                        "
                        :testCategory="TEST_CATEGORY"
                        :canScore="examInfo.can_score"
                        :scored="examInfo.is_scored"
                        @unlock="$parent.getAlert()"
                      />
                    </div>
                  </div>
                  <div>
                    <div v-if="isAdmin">
                      <template v-if="examInfo.can_suggest === 1">
                        <div class="overall-comments">
                          <b>Overall Comments:&nbsp;</b>
                        </div>
                        <el-input
                          class="transcript"
                          type="textarea"
                          :rows="8"
                          placeholder="Please enter content"
                          v-model="question_detail.suggest"
                          :disabled="false"
                        >
                        </el-input>
                      </template>
                      <div
                        class="text-left mt-3"
                        v-if="
                          examInfo.can_suggest === 1 &&
                            examInfo.suggest_type === 'detail'
                        "
                      >
                        <el-input
                          v-model="
                            (question_detail.answer_score_detail || {}).overall_comment_url
                          "
                        >
                          <template slot="prepend">
                            <i class="fas fa-file-alt"></i> <b>Doc URL:</b>
                          </template>
                        </el-input>
                      </div>
                      <div class="mt-4">
                        <el-button
                          @click="saveTranscript"
                          size="mini"
                          type="success"
                        >
                          <i class="fa fa-save"></i> Save
                        </el-button>
                      </div>
                    </div>
                    <div v-else>
                      <div style="margin-top:40px">
                        <div class="overall-comments">
                          <b>Overall Comments:&nbsp;</b>
                        </div>
                      </div>
                      <div v-if="examInfo.can_suggest === 1">
                        <div
                          v-if="examInfo.is_scored === 1"
                          style="word-break: normal !important;"
                          v-html="question_detail.suggest"
                        ></div>
                        <div v-else>
                          <el-button type="success" disabled plain round>
                            {{ $t("message.pendingComments") }}
                          </el-button>
                        </div>
                        <div
                          class=" mt-3"
                          v-if="
                            examInfo.can_suggest === 1 &&
                              examInfo.suggest_type === 'detail' &&
                              (question_detail.answer_score_detail || {}).overall_comment_url
                          "
                        >
                          <div class="overall-comments score-title">
                            <b>Doc URL:</b>
                          </div>
                          <a
                            :href="
                              question_detail.answer_score_detail.overall_comment_url
                            "
                            ><i class="fas fa-file-alt"></i> <b>Doc.</b></a
                          >
                        </div>
                      </div>
                      <el-button
                        v-else
                        type="warning"
                        @click="$parent.getAlert()"
                      >
                        {{
                          $t("ielts.balance.Get Comments for This Prompt")
                        }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="resolve_content">
            <div class="title">Sample Answer:</div>
            <div class="exp">
              <div
                v-if="lang === 'ZH-TW' || lang === 'EN-US'"
                v-html="traditionalized(question_detail.exp)"
              ></div>
              <div v-else v-html="question_detail.exp"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import IELTS from "@/apis/ielts.js";
import Translate from "@/mixins/translate.js";
import role from "@/mixins/role.js";
import GradeLevelSelector from "@/views/ielts/grading/sections/GradeLevelSelector";
import GradingSubScoreTable from "@/views/ielts/grading/sections/SubScoreTable";
import SubScoreTable from "@/views/ielts/transcript/components/SubScoreTable";

export default {
  props:["passageDetail", "questionId", "examInfo", "title", "lang"],
  mixins: [Translate, role],
  components: {
    SubScoreTable,
    GradeLevelSelector,
    GradingSubScoreTable
  },
  data() {
    return {
      showPassage: false
    };
  },
  computed:{
    question_detail() {
      const questions = this.passageDetail.ielts_question_sets[0].ielts_questions;
      return questions.find(({ id }) => (
        id === this.questionId
      ));
    },
    isAdmin() {
      let isAdmin = this.isRoleAdmin();
      return isAdmin;
    },
    TEST_CATEGORY() {
      return "writing_all";
    }
  },
  methods: {
    setText(text) {
      return text.replace(/\n/g, "<br />");
    },
    getArr(arr) {
      arr.forEach(val => {
        let newVal = {
          id: val.user_exam_answer_id,
          score: val.score,
          suggest: val.suggest,
          answer_score_detail: {
            comment_type: this.TEST_CATEGORY,
            detail_score_comments: val.answer_score_detail.detail_score_comments
          }
        };
        this.updateAnswers.push(newVal);
      });
    },
    async saveTranscript() {
      this.updateAnswers = [];
      this.getArr([this.question_detail]);
      await IELTS.updateTranscript(this.$route.query.user_exam_id, {
        user_exam_answers: this.updateAnswers
      });
      this.$notify({
        title: "Success!",
        type: "success",
        position: "bottom-right",
        duration: "1000"
      });
    }
  }
};
</script>

<style scoped>
.speaking_resolve {
  margin-top: 30px;
}
.passage {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
}
.vip {
  color: #f0ad4e;
}
.vip >>> .el-tag {
  margin-right: 8px;
  height: 20px;
  line-height: 18px;
  padding: 0 4px;
}

.open {
  left: auto;
  right: -11px;
}

.chart {
  width: 100%;
}
</style>
